








import { Component, Prop, Vue } from "vue-property-decorator";
import CSelect, { SelectOption } from "@/basics/selects/CSelect.vue";

// GraphQL
import { AvailableAppUserData, AVAILABLE_APP_USERS } from "@/graphql/query/appUser/available";

@Component({
  components: { CSelect },
  apollo: {
    appUsers: {
      query: AVAILABLE_APP_USERS,
      update(data: AvailableAppUserData): SelectOption[] {
        return data.appUserAvailableFeed.appUsers.map(u => ({
          text: u.name,
          value: u.id
        }));
      }
    }
  }
})
export default class AppUsersSelect extends Vue {
  @Prop({ type: String, required: false, default: null })
  name!: string | null;

  @Prop({ type: String, required: false, default: null })
  value!: string | null;
}
